import Vue from "./vue";
// import App from './App.vue';
import App from "./AppIndex.vue";
import router from "./router";
import store from "./store/";
import vuetify from "./plugins/vuetify";
import VueSignalR from "@latelier/vue-signalr";
// import http from '@/plugins/axios';
import DatetimePicker from "vuetify-datetime-picker";

let NavScroll = require("navscroll");
Vue.use(NavScroll);
// Vue.prototype.$axios = http;
// window.$axios = http;
// store.$axios = http;

Vue.config.productionTip = false;
//Vue.use(VueSignalR, "https://colmenan.ugto.mx/Notificacion/notificacion");
Vue.use(DatetimePicker);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
